<div #mapElement [ngClass]="{ disabled }" class="map"></div>
